import type { NskResponse } from "~/models/Api";
import { putRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const bulkUpdate = async (
	propertyDealId: number,
	expectedAccountingDate: string
): Promise<NskResponse> =>
	putRequest(
		generatePath(
			"/property_deals/:property_deal_id/deal_expected_accounting_dates",
			{
				property_deal_id: propertyDealId
			}
		),
		{ expectedAccountingDate }
	);
